import { createSlice, PayloadAction } from "@reduxjs/toolkit";

import { DeliveryScheduleDocumentFragment } from "~/gql/queries/restock/deliverySchedules.generated";

interface DeliveryScheduleState {
	scheduleFormOpen: boolean;
	selectedSchedule?: DeliveryScheduleDocumentFragment;
	storesModalOpen: boolean;
}

const initialState: DeliveryScheduleState = {
	scheduleFormOpen: false,
	storesModalOpen: false
};

export const deliveryScheduleSlice = createSlice({
	initialState,
	name: "deliverySchedule",
	reducers: {
		clearSelectedSchedule: (state) => {
			state.selectedSchedule = undefined;
		},
		closeScheduleForm: (state) => {
			state.scheduleFormOpen = false;
		},
		closeStoresModal: (state) => {
			state.storesModalOpen = false;
		},
		openScheduleForm: (state) => {
			state.scheduleFormOpen = true;
		},
		openStoresModal: (state) => {
			state.storesModalOpen = true;
		},
		setSelectedSchedule: (state, action: PayloadAction<DeliveryScheduleDocumentFragment | undefined>) => {
			state.selectedSchedule = action.payload;
		}
	}
});

export const {
	clearSelectedSchedule,
	closeScheduleForm,
	closeStoresModal,
	openScheduleForm,
	openStoresModal,
	setSelectedSchedule
} = deliveryScheduleSlice.actions;

export default deliveryScheduleSlice.reducer;
